import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Emits when a click happens outside the host element.
 * Used by the Topbar (and later any dropdown/flyout) to close itself
 * without each component re-implementing the same document listener.
 */
@Directive({
  selector: '[ppClickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output() ppClickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: EventTarget | null): void {
    if (target instanceof Node && !this.elementRef.nativeElement.contains(target)) {
      this.ppClickOutside.emit();
    }
  }
}
